import { Radio } from 'antd';
import styled, { css } from 'styled-components';
import { getRadioStyle } from '../utils/getRadioStyle';

export const StyledRadio = styled(Radio)<{ $hasChildren: boolean }>`
  align-items: flex-start;
  line-height: ${({ $hasChildren }) => ($hasChildren ? 'inherit' : '0')};

  .ant-radio {
    align-self: flex-start;
    margin-top: ${({ $hasChildren }) => ($hasChildren ? '3px' : '0')};
  }

  ${({ $hasChildren }) =>
    !$hasChildren &&
    css`
      span:nth-of-type(2) {
        display: none;
        margin-top: 1px;
      }
    `}

  ${getRadioStyle}
`;
